<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img
          class="solutionDetailTitle1"
          src="../../static/images/solutionText14.png"
        />
        <br />
        <img
          class="solutionDetailTitle2"
          src="../../static/images/solutionText15.png"
        />
        <div class="solutionDetailText">
          公司致力于成为新型智慧城市解决方案领导者，充分运用最新的信息化技术，构建完整、可灵活扩展的智慧城市总体框架，秉承“平台+生态”的策略，打造新型智慧城市数字大脑，落地“1+1+N“的总体建设框架，提供支撑新型智慧城市建设的创新数字化解决方案和服务。
        </div>
        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">城市运行管理平台</div>
            <div class="solutionDetailSecondText">
              公司利用云计算、物联网、互联网、大数据等技术将城市海量信息一网打尽，通过智能化的分析，为政府提供一个可视化平台，是智慧城市建设、管理、运营的“大脑”。旨在通过监测城市实时运行状态，科学分析城市运行数据，可视化业务呈现，事件智能化预警、智能化处置，信息动态发布与共享，为城市精细化、科学化管理提供技术和决策支持，提高城市整体运行效率、社会治理能力、城市综合水平管理，促进城市运行管理和服务整合，形成可持续发展模式。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic24.png"
            />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic25.png"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">智慧园区</div>
            <div class="solutionDetailSecondText">
              智慧园区解决方案依托强大的集成管理云平台，通过分布式的数据采集中心，连接前端各专业智能化系统，以及物联网感知设备，实时准确获取设备运行数据、能源使用数据、环境状态数据等，应用大数据决策分析引擎，进行海量数据的分析、统计、诊断，筛选价值数据进行丰富多元的智能化控制，为产业园区提供统一运维管理服务，实现园区用能管理效率的提高，运维成本的降低，建立统一的应急管理与日常管理、对内与对外服务的管理体系，满足“安全、高效、绿色”的现代产业园区建设规划要求
            </div>
          </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail7.vue